import { Controller } from "@hotwired/stimulus"

// Progressive disclosure of scope inputs when adding a new user.
// Shows scope-type and employer picker when a role is selected.
export default class extends Controller {
  static targets = ["roleSelect", "scopeFields", "scopeTypeSelect", "employerSelect"]

  connect() {
    this.toggleScopeFields()
  }

  onRoleChange() {
    this.toggleScopeFields()
  }

  onScopeTypeChange() {
    this.toggleEmployerSelect()
  }

  toggleScopeFields() {
    const hasRole = this.roleSelectTarget.value !== ""
    this.scopeFieldsTarget.classList.toggle("hidden", !hasRole)

    if (hasRole) {
      this.toggleEmployerSelect()
    }
  }

  toggleEmployerSelect() {
    const isEmployer = this.scopeTypeSelectTarget.value === "Employer"
    this.employerSelectTarget.classList.toggle("hidden", !isEmployer)
  }
}
